module.exports = __webpack_public_path__ + "img/uid-token-game-guide-th.5e9da72f.png";